import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import {
  SKELETON_BUTTON_SIZES,
  SKELETON_ICON_SIZES,
  SKELETON_LEAD_SIZES,
  SKELETON_SHAPES,
  SKELETON_TEXT_SIZES,
  SKELETON_VARIANTS,
  SkeletonShape,
  SkeletonSize,
  SkeletonVariant,
} from './skeleton.types';

@Component({
  selector: 'evc-skeleton',
  templateUrl: './skeleton.component.html',
  styleUrl: './skeleton.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[attr.data-variant]': 'variant()',
    '[attr.data-size]': 'resolvedSize()',
    '[attr.data-shape]': 'shape()',
  },
})
export class SkeletonComponent {
  variant = input<SkeletonVariant>(SKELETON_VARIANTS.text);
  size = input<SkeletonSize | undefined>(undefined);
  shape = input<SkeletonShape>(SKELETON_SHAPES.round);
  width = input<string | undefined>(undefined);
  height = input<string | undefined>(undefined);

  private readonly sizeDefaults: Record<SkeletonVariant, SkeletonSize | undefined> = {
    text: SKELETON_TEXT_SIZES.MEDIUM,
    icon: SKELETON_ICON_SIZES.MEDIUM,
    'lead-visual': SKELETON_LEAD_SIZES.MEDIUM,
    button: SKELETON_BUTTON_SIZES.SMALL,
    block: undefined,
  };

  readonly resolvedSize = computed(() => this.size() ?? this.sizeDefaults[this.variant()]);

  readonly customStyles = computed<Record<string, string>>(() => {
    const styles: Record<string, string> = {};
    const w = this.width();
    const h = this.height();
    if (w) styles['width'] = w;
    if (h) styles['height'] = h;
    return styles;
  });
}
